import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { CONTACT_WIZARD_SAMPLE } from "../consts";
import { getContactName } from "../helpers";
import { ContactWizardSceneProps } from "../types";

/** Korak "Bilješke": bilješke uz kontakt, važna istaknuta, i nova bilješka u pisanju. */
const NotesScene: React.FC<ContactWizardSceneProps> = ({ formValues }) => {
  const name = getContactName(formValues);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Bilješke</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {CONTACT_WIZARD_SAMPLE.notes.map((note) => (
              <div
                key={note.content}
                className={
                  note.important
                    ? "rounded-md border-l-4 border-amber-400 bg-amber-50 px-3 py-2 text-[0.7rem]"
                    : "rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]"
                }
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="text-[0.6rem] text-slate-400">{note.date}</span>
                  {note.important && <span className="text-[0.55rem] font-semibold uppercase text-amber-700">Važno</span>}
                </div>
                <p className="mt-0.5 font-medium text-slate-700 line-clamp-2">{note.content}</p>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Nova bilješka</div>
          <div className="mt-3 space-y-2">
            <div className="h-1.5 w-full rounded-full bg-slate-100" />
            <div className="h-1.5 w-5/6 rounded-full bg-slate-100" />
            <div className="h-1.5 w-2/5 rounded-full bg-blue-200" />
          </div>
          <div className="mt-3 flex items-center gap-2 text-[0.65rem] text-slate-500">
            <span className="w-3 h-3 rounded-sm bg-amber-400" />
            <span>Označi kao važno</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Dogovori ostaju zapisani"
          subtitle="Uz datum i autora bilješke"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 20h9M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NotesScene);
